import imageCompression from 'browser-image-compression';

export interface CompressOptions {
    maxSizeMB: number;
    maxWidthOrHeight?: number;
}

export async function compressImage(file: File, opts: CompressOptions): Promise<File> {
    if (file.size <= opts.maxSizeMB * 1024 * 1024) {
        return file;
    }
    return imageCompression(file, {
        maxSizeMB: opts.maxSizeMB,
        maxWidthOrHeight: opts.maxWidthOrHeight ?? 2048,
        useWebWorker: true,
        fileType: file.type as any,
    });
}

export function fileToDataURL(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
